import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';
import { bindActionCreators } from 'redux';
// import classNames from 'classnames';
// import Products from './components/Products';

import { Button, FormControlLabel, MenuItem, Radio, Typography } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import TextField from 'material-ui/TextField';
import Formsy from 'formsy-react';
import $ from "jquery";

// import PropTypes from 'prop-types';
import FileUpload from '@material-ui/icons/FileUpload';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import DeleteIcon from '@material-ui/icons/Delete';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import AddIcon from '@material-ui/icons/Add';
import axios from 'axios';
import Tooltip from 'material-ui/Tooltip';

import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import ReactTable from "react-table";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { withAlert } from 'react-alert';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },

    tableRowWH: {
        width: 30,
        height: 20
    }
});


var editEmploymentId = null;
var editEmploymentName = null;

class Tab4Employement extends Component {

    state = {
        value: 0
    };

    constructor(props) {
        super(props);

        this.state = {
            data: []
        };

        this.loadData();
    }

    // clear employement creation form
    clearEmployeementForm() {
        $("#employementForm")[0].reset();
    }

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    handleCloseActive = () => {
        this.setState({ active: false });
    };

    // active designation
    onActive = (model) => {
        this.activeEmployement(model);
    }


    // load all greades
    loadData() {
        var data = [];

        axios.get(window.hrmServer+'/getEmployment')
            .then(response => {
                if (response.data.success) {

                    var employmentObj = response.data.result;

                    for (var i = 0; i < employmentObj.length; i++) {

                        data.push({
                            employmentId: employmentObj[i].ID_EMPLOYEMENT,
                            employmentName: employmentObj[i].EMPLOYEMENT,
                            status: employmentObj[i].STATUS
                        });
                    }
                }
                this.setState({ data: data });

            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error");
                this.props.alert.error("No internet connection or Internal error !");

            });

        this.handleCloseEdit();
    }

    // save designation
    onSubmit = (model) => {
        this.saveEmployement(model);
    };

    // edit designation 
    onEdit = (model) => {
        this.editEmployment(model);
    };

    // delete designation
    onDelete = (model) => {
        this.deleteEmployement(model);
    };

    // create Greade
    saveEmployement(model) {

        const greadeObj = {
            employementName: model.employementName
        }
        // axios.post('http://localhost:5002/createEmployment', greadeObj)
        axios.post(window.hrmServer+'/createEmployment', greadeObj)
            .then(res => {

                if (res.data.success) {

                    if (res.data.message == "DUPLICATE") {

                        this.props.alert.info("Already Input This Employment Type !");

                    } else {

                        this.props.alert.success("New Employment Saved Successfully");
                        this.loadData();
                        $("#employementForm")[0].reset();

                    }

                } else {
                    this.props.alert.error("Unable to Saved Please Check !");
                }
            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error");
                this.props.alert.error("No internet connection or Internal error !");

            });
    }

    // edit Employment
    editEmployment(model) {
        const employementObj = {
            employmentId: model.editEmploymentId,
            employmentName: model.editEmploymentName
        }

        axios.post(window.hrmServer+'/editEmployment', employementObj)
            .then(res => {

                if (res.data.success) {

                    if (res.data.message == "DUPLICATE") {

                        this.props.alert.info("Already Input This Employment Type !");

                    } else {

                        this.props.alert.success("Employment Updated Successfully");
                        this.loadData();
                        $("#employementForm")[0].reset();

                    }

                } else {

                    this.props.alert.error("Unable to Updated Please Check !");

                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                this.props.alert.error("No internet connection or Internal error !");

            });
    }

    // inactive employement
    deleteEmployement(model) {
        var employementId = model.deleteEmployementId;

        if (null == employementId || "" == employementId || undefined == employementId) {

            this.props.alert.error("Cannot Inactivated this Employement !");

        } else {

            var deleteObj = {
                employementId: employementId
            }

            axios.post(window.hrmServer+'/deleteEmployement', deleteObj)
                .then(response => {

                    if (response.data.success) {

                        this.props.alert.success("Employment Inactivated Successfully");
                        this.handleCloseDelete();
                        this.loadData();

                    } else {

                        this.props.alert.error("Unable to Inactivated Please Check !");

                    }

                }).catch(function (error) {

                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    this.props.alert.error("No internet connection or Internal error !");

                });
        }
    }

    // active employement 
    activeEmployement(model) {
        var employementId = model.deleteEmployementId;

        if (null == employementId || "" == employementId || undefined == employementId) {

            this.props.alert.error("Cannot Activate this Employement !");

        } else {

            var activeObj = {
                employementId: employementId
            }

            axios.post(window.hrmServer+'/activeEmployement', activeObj)
                .then(response => {

                    if (response.data.success) {

                        this.props.alert.success("Employment Activated Successfully");
                        this.handleCloseActive();
                        this.loadData();

                    } else {

                        this.props.alert.error("Unable to Activated Please Check !");

                    }

                }).catch(function (error) {

                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    this.props.alert.error("No internet connection or Internal error !");

                });
        }
    }

    render() {

        const { classes, setSearchText, searchText } = this.props;
        const { value } = this.state;

        return (
            <div className="{classes.root} mt-16">
                <Formsy
                    id="employementForm"
                    onValidSubmit={this.onSubmit}
                    onValid={this.enableButton}
                    onInvalid={this.disableButton}
                    ref={(form) => this.form = form}
                    className="flex flex-col justify-center"
                >
                    <div className="flex flex-wrap -mx-3 mb-6">
                        <TextFieldFormsy
                            className="w-full md:w-1/4"
                            type="text"
                            name="employementName"
                            label="Employment Name"
                            required
                        />

                        <div className="w-full md:w-2/3"></div>
                        
                    </div>

                   <DialogActions className="justify-right pl-16">
                    <div className="w-full md:w-1/3 float-right mb-16 department-btn-padding">
                            {/* onClick={this.saveEmployee.bind(this)} */}

                            <Button type="submit" variant="raised" size="medium" color="secondary" className="{classes.button}  w-full md:w-1/3 md:h-24 mt-16 mr-8">
                                Save
                            </Button>

                            <Button type="button" onClick={this.clearEmployeementForm} variant="raised" size="medium" className="{classes.button}  w-full md:w-1/3 md:h-24 mt-16 mr-8">
                                Clear
                            </Button>
                        </div>
                      </DialogActions>  
                </Formsy>


                {/* <div className="flex flex-wrap -mx-3 mb-12">
                    <div className="w-full md:w-2/3"></div>
                    <div className="w-full md:w-1/3">
                        <TextField
                            placeholder="Search for anything"
                            className="pl-16"
                            fullWidth
                            value={searchText}
                            inputProps={{
                                'aria-label': 'Search'
                            }}
                            onChange={setSearchText}
                        />
                    </div>
                </div> */}


                <div class="flex h-auto">

                    <div class="w-full bg-white h-auto">
                        <ReactTable
                            getTrProps={(state, rowInfo, column) => {
                                return {
                                    className: "cursor-pointer",
                                    onClick: (e, handleOriginal) => {

                                    }
                                }
                            }}
                            data={this.state.data}
                            columns={[
                                {
                                    Header: "Employment Id",
                                    accessor: "employmentId",
                                    show: false
                                },
                                {
                                    Header: "Status",
                                    accessor: "status",
                                    show: false
                                },
                                {
                                    Header: "Employment Name",
                                    accessor: "employmentName",
                                    filterable: true,
                                    Cell: ({ row, original }) => (
                                        <span>
                                            <span style={{

                                                color: original.status == 1 ? '#57d500' : '#Ff0000',
                                                transition: 'all .3s ease'
                                            }}>
                                                &#x25cf;
                                            </span>
                                            {
                                                row.value == '' ? ' '
                                                    : row.employmentName
                                            }
                                        </span>
                                    ),

                                },
                                {
                                    Header: "Action",
                                    // accessor: "su",
                                    width: 128,
                                    Cell: row => (

                                        row.original.status == 1 ? (
                                            <div className="flex items-center w-8 h-8">
                                                <Tooltip
                                                    enterDelay={300}
                                                    id="tooltip-controlled"
                                                    leaveDelay={300}
                                                    onClose={this.handleTooltipClose}
                                                    onOpen={this.handleTooltipOpen}
                                                    open={this.state.open}
                                                    placement="bottom"
                                                    title="Do you want to inactive ?"
                                                >
                                                    <IconButton
                                                        onClick={(e) => {
                                                            if (row) {

                                                                editEmploymentId = row.original.employmentId;
                                                                editEmploymentName = row.original.employmentName;
                                                                this.setState({ delete: true });
                                                            }
                                                        }}
                                                    >
                                                        <Icon className="text-green">check_circle</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                                <Dialog
                                                    open={this.state.delete}
                                                    onClose={this.handleClose}
                                                    aria-labelledby="form-dialog-title"
                                                >
                                                    <DialogTitle id="form-dialog-title">Inactive Employement </DialogTitle>
                                                    <DialogContent>

                                                        <div>
                                                            <Formsy
                                                                onValidSubmit={this.onDelete}
                                                                onValid={this.enableButtonDelete}
                                                                onInvalid={this.disableButtonDelete}
                                                                ref={(form) => this.form = form}
                                                                className="flex flex-col justify-center"
                                                            >

                                                                <TextFieldFormsy
                                                                    type="hidden"
                                                                    name="deleteEmployementId"
                                                                    value={editEmploymentId}
                                                                />

                                                                <div className="w-full">
                                                                    Are you sure inactive <h4>{editEmploymentName + " ?"}</h4>
                                                                </div>

                                                                <DialogActions>
                                                                    <Button onClick={this.handleCloseDelete} color="primary">
                                                                        Cancel
                                                                    </Button>
                                                                    <Button color="primary" autoFocus
                                                                        type="submit"
                                                                    >
                                                                        Inactive
                                                                    </Button>
                                                                </DialogActions>
                                                            </Formsy>
                                                        </div>
                                                    </DialogContent>
                                                </Dialog>

                                                <Tooltip
                                                    enterDelay={300}
                                                    id="tooltip-controlled"
                                                    leaveDelay={300}
                                                    onClose={this.handleTooltipClose}
                                                    onOpen={this.handleTooltipOpen}
                                                    open={this.state.open}
                                                    placement="bottom"
                                                    title="Edit Employement"
                                                >
                                                    <IconButton

                                                        onClick={(e) => {
                                                            if (row) {
                                                                editEmploymentId = row.original.employmentId;
                                                                editEmploymentName = row.original.employmentName;
                                                                this.setState({ edit: true });
                                                            }
                                                        }}

                                                    >
                                                        <Icon className="text-blue">mode_edit</Icon>
                                                    </IconButton>
                                                </Tooltip>

                                                <Dialog
                                                    open={this.state.edit}
                                                    onClose={this.handleCloseEdit}
                                                    aria-labelledby="form-dialog-title"
                                                >
                                                    <DialogTitle id="form-dialog-title">Edit Employement Type</DialogTitle>
                                                    <DialogContent>

                                                        <div>
                                                            <Formsy
                                                                onValidSubmit={this.onEdit}
                                                                onValid={this.enableButtonEdit}
                                                                onInvalid={this.disableButtonEdit}
                                                                ref={(form) => this.form = form}
                                                                className="flex flex-col justify-center"
                                                            >
                                                                <TextFieldFormsy
                                                                    type="hidden"
                                                                    name="editEmploymentId"
                                                                    value={editEmploymentId}
                                                                />

                                                                <TextFieldFormsy
                                                                    className="mb-24 mx-20"
                                                                    type="text"
                                                                    name="editEmploymentName"
                                                                    label="Greade Name"
                                                                    value={editEmploymentName}
                                                                    required

                                                                />

                                                                <DialogActions>
                                                                    <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full  md:h-24">
                                                                        Close
                                                                </Button>

                                                                    <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:h-24 ">
                                                                        Update
                                                                </Button>
                                                                </DialogActions>
                                                            </Formsy>
                                                        </div>
                                                    </DialogContent>
                                                </Dialog>


                                            </div>) : (<div className="flex items-center w-8 h-8">
                                                <Tooltip
                                                    enterDelay={300}
                                                    id="tooltip-controlled"
                                                    leaveDelay={300}
                                                    onClose={this.handleTooltipClose}
                                                    onOpen={this.handleTooltipOpen}
                                                    open={this.state.open}
                                                    placement="bottom"
                                                    title="Do you want to active ?"
                                                >
                                                    <IconButton
                                                        onClick={(e) => {
                                                            if (row) {

                                                                editEmploymentId = row.original.employmentId;
                                                                editEmploymentName = row.original.employmentName;
                                                                this.setState({ active: true });
                                                            }
                                                        }}
                                                    >
                                                        <Icon className="text-red">cancel</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                                <Dialog
                                                    open={this.state.active}
                                                    onClose={this.handleClose}
                                                    aria-labelledby="form-dialog-title"
                                                >
                                                    <DialogTitle id="form-dialog-title">Active Employement </DialogTitle>
                                                    <DialogContent>

                                                        <div>
                                                            <Formsy
                                                                onValidSubmit={this.onActive}
                                                                onValid={this.enableButtonDelete}
                                                                onInvalid={this.disableButtonDelete}
                                                                ref={(form) => this.form = form}
                                                                className="flex flex-col justify-center"
                                                            >

                                                                <TextFieldFormsy
                                                                    type="hidden"
                                                                    name="deleteEmployementId"
                                                                    value={editEmploymentId}
                                                                />

                                                                <div className="w-full">
                                                                    Are you sure active <h4>{editEmploymentName + " ?"}</h4>
                                                                </div>

                                                                <DialogActions>
                                                                    <Button onClick={this.handleCloseActive} color="primary">
                                                                        Cancel
                                                                    </Button>
                                                                    <Button color="primary" autoFocus
                                                                        type="submit"
                                                                    >
                                                                        Active
                                                                    </Button>
                                                                </DialogActions>
                                                            </Formsy>
                                                        </div>
                                                    </DialogContent>
                                                </Dialog>

                                            </div>)
                                    )
                                }
                            ]}
                            defaultPageSize={10}
                            className="-striped -highlight"
                        />
                    </div>
                </div>

            </div>
        )
    }

}


export default withStyles(styles, { withTheme: true })(withAlert(Tab4Employement));


// WEBPACK FOOTER //
// ./src/main/content/hr/systemSetting/components/Tab4Employement.js